import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';
import { getTenderPackageDetailsQuery } from '@/app/hooks/queries/useTenderPackages';
import { Main } from '@/app/ui/components/main';
import { ChatType, EvaluationTypeLabelsEnum } from '@/app/utils/constants';
import AIChatProvider from '@/app/components/features/aiChat/AIChatContext';
import useEntryChat from '@/app/components/features/aiChat/hooks/useEntryChat';
import { Sidechat } from '@/app/components/shared/Sidechat';
import { Spinner } from '@/app/ui/components/spinner';
import { useSuspenseQuery } from '@tanstack/react-query';
import { VersionHistoryPanel } from '@/app/components/features/evaluations/VersionHistoryPanel/VersionHistoryPanel';

export const Route = createFileRoute(
  '/_authed/project/$projectId/_layout/(evaluation)/tender-packages/$tenderPackageId/_layout',
)({
  component: RouteComponent,
  loader: async (opts) => {
    const evaluation = await opts.context.queryClient.ensureQueryData(
      getTenderPackageDetailsQuery(opts.params.tenderPackageId),
    );
    if (!evaluation) throw notFound();
  },
  pendingComponent: () => (
    <Main className="relative">
      <Spinner kind="inset" />
    </Main>
  ),
});

function RouteComponent() {
  const { tenderPackageId } = Route.useParams();
  const { data: evaluation } = useSuspenseQuery(getTenderPackageDetailsQuery(tenderPackageId));

  const stream = useEntryChat({
    id: tenderPackageId,
    namespace: ChatType.RFP,
  });

  return (
    <AIChatProvider
      chatType={ChatType.RFP}
      sourceStream={stream}
      chatInitialOpen={false}
      evaluationName={evaluation.name}
      evaluationType={EvaluationTypeLabelsEnum.TENDER_PACKAGE}
      evaluationId={tenderPackageId}
    >
      <Main>
        <Outlet />
      </Main>
      <VersionHistoryPanel evalId={tenderPackageId} />
      <Sidechat />
    </AIChatProvider>
  );
}
